import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'
import { fetchTsIds } from './shared/parallelFetch'
import { useToFill } from './shared/useToFill'

export function useYearlyData(ghId, yearFrom, yearTo, tsIds) {
  const queryKey = ['yearlyData', ghId, yearFrom, yearTo, tsIds]

  const { data, isLoading, isError, error } = useQuery({
    queryKey,
    queryFn: async () => {
      const responses = await fetchTsIds(
        tsIds,
        tsId => api.get(`/sdata_ts?ts_id=${tsId}&gh_id=${ghId}&year_from=${yearFrom}&year_to=${yearTo}&stype=YEAR`),
      )
      const result = responses.map(r => r?.data ?? [])
      const toFill = responses.flatMap(r => r?.to_fill ?? [])
      return { result, toFill }
    },
    enabled: !!ghId && !!yearFrom && !!yearTo && tsIds.length > 0,
    staleTime: 5 * 60 * 1000,
  })

  // Živé = rozsah zasahuje do letoška.
  const live = Number(yearTo) >= new Date().getUTCFullYear()

  useToFill(queryKey, data, (result, resp, item) => {
    const i = tsIds.indexOf(item.params?.ts_id)
    if (i < 0) return result
    const next = result.slice()
    next[i] = resp.data
    return next
  }, { gran: 'YEAR', live })

  const dataMap = {}
  if (data?.result) {
    tsIds.forEach((tsId, i) => {
      dataMap[tsId] = {}
      ;(data.result[i] ?? []).forEach(row => {
        if (row.year) dataMap[tsId][String(row.year)] = row.value ?? null
      })
    })
  }

  return { dataMap, isLoading, isError, error }
}
